import dayjs, { Dayjs } from "dayjs";
import mastercardImage from '../../imagens/mastercardsemfundo.png';
import visa from '../../imagens/visa.png';
import americanExp from "../../imagens/americanexpress.png"
import discover from "../../imagens/discover.png"

function formatDateAtaul(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const formatCNPJ = (cnpj) => {
  if (!cnpj) return ""; // Verifica se o CNPJ é nulo ou indefinido e retorna uma string vazia
  cnpj = cnpj.replace(/\D/g, "");
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
};

const formatCPF = (cpf) => {
  if (!cpf) return ""; // Verifica se o CPF é nulo ou indefinido e retorna uma string vazia
  cpf = cpf.replace(/\D/g, ""); // Remove todos os caracteres não numéricos
  return cpf.replace(
    /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
    "$1.$2.$3-$4"
  );
};

const formatTelefone = (telefone) => {
  if (!telefone) return ""; // Verifica se o telefone é nulo ou indefinido e retorna uma string vazia
  telefone = telefone.replace(/\D/g, ""); // Remove todos os caracteres não numéricos

  if (telefone.length === 10) {
    // Formato para telefones fixos: (XX) XXXX-XXXX
    return telefone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  } else if (telefone.length === 11) {
    // Formato para celulares: (XX) XXXXX-XXXX
    return telefone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else {
    // Retorna o telefone original se não for um número válido
    return telefone;
  }
};

const formatCEP = (cep) => {
  if (!cep) return ""; // Verifica se o CEP é nulo ou indefinido e retorna uma string vazia
  cep = cep.replace(/\D/g, ""); // Remove todos os caracteres não numéricos
  return cep.replace(/^(\d{5})(\d{3})$/, "$1-$2"); // Aplica a formatação
};

const handleInputChange = async (e, setFilterClient, updateClientDetails) => {
  const value = e.target.value;
  if (/^\d*$/.test(value)) {
    setFilterClient(value);
    await updateClientDetails(value);
  }
};

const handleInput = async (e, setFilterClient) => {
  const value = e.target.value;
  if (/^\d*$/.test(value)) {
    setFilterClient(value);
  }
};

const formatNumber = (number) => {
  return new Intl.NumberFormat('pt-BR').format(number);
};

const formatValueBrl = (number) => {
    if (!number) return 'R$0,00'; // Retorna uma string vazia se o número for nulo ou indefinido
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);
}

export const limparFormatValueBrl = (value) => {
    if (value === null || value === undefined || value === "") return null;
    
    let strValue = String(value);

    // 1. Limpa a formatação de moeda e separadores de milhar (R$, espaços, pontos)
    strValue = strValue.replace(/[R$\s\.]/g, ''); 
    
    // 2. Substitui a vírgula decimal (brasileira) por ponto (padrão numérico)
    strValue = strValue.replace(/,/g, '.');

    // 3. Converte para número (Double/Float)
    const numericValue = parseFloat(strValue);

    if (isNaN(numericValue)) {
        return null; // Retorna nulo se o resultado não for um número válido
    }

    // 🎯 4. Verifica se o valor é um inteiro (ex: 161.00 deve ser 161)
    if (numericValue % 1 === 0) {
        return parseInt(numericValue); // Retorna inteiro
    }
    
    // 5. Caso contrário (se tiver centavos), retorna o float/double
    return numericValue;

  }

  
export const formatCurrencyBR = (amount) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
    }).format(amount);
};

const formatValueBrl2 = (inputValue) => {
  // Remove caracteres inválidos
  const cleanedValue = inputValue.replace(/[^\d]/g, '');

  // Garante pelo menos dois dígitos para centavos
  const numericValue = cleanedValue.padStart(3, '0');

  // Divide entre reais e centavos
  const reais = numericValue.slice(0, -2);
  const centavos = numericValue.slice(-2);

  // Formata com separadores corretos
  const formattedReais = new Intl.NumberFormat('pt-BR').format(parseInt(reais, 10));

  return `R$ ${formattedReais},${centavos}`;
};

const formatDate = (date) => {
  if (!date) return ""; // Verifica se a data é nula ou indefinida e retorna uma string vazia
  date = date.replace(/\D/g, ""); // Remove todos os caracteres não numéricos
  if (date.length !== 8) return date; // Verifica se a data tem 8 dígitos (DDMMAAAA)
  return date.replace(
    /^(\d{2})(\d{2})(\d{4})$/,
    "$1/$2/$3"
  );
};

const formatarData = (dataMillis) => {
  return dayjs(dataMillis).format("DD/MM/YYYY HH:mm:ss"); // Formato desejado
};

const formatCurrency = (value) => `R$ ${value}`;

const formatarTamanho = (bytes) => {
  if (!bytes) return "0 KB";
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(1)} MB`;
};

export const limitarTexto = (texto, limite = 30) => {
  if (!texto) return "";
  return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
};

export const limitarTexto25 = (texto, limite = 25) => {
  if (!texto) return "";
  return texto.length > limite ? texto.substring(0, limite) + "..." : texto;
};

export const getDiasCategoria = (dias) => {
  if (dias >= 16 && dias <= 30) return 3; // mais atrasados
  if (dias >= 11 && dias <= 15) return 2; // meio
  return 1; // até 10 dias
};

export const getRowStyle = (item) => {
  if (Number(item.quantidadePrevisto) > Number(item.quantidadeEmitido)) {
    // Pendentes
    return {
      background: "#FFF3E0",
      color: "#F57C00",
    };
  } else if (Number(item.quantidadePrevisto) === Number(item.quantidadeEmitido)) {
    // Concluídos
    return {
      background: "#E8F5E9",
      color: "#388E3C",
    };
  }
  return {};
};

export const formatDigitandoCNPJ = (value) => {
  return value
    .replace(/\D/g, "") // remove tudo que não é número
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2")
    .slice(0, 18); // limita no tamanho do CNPJ
};

export const formatCardNumber = (num) => {

    const cleanNum = (num || '').toString();
 
    if (!cleanNum) {
        return ''; 
    }

    return cleanNum.replace(/\s?/g, '').replace(/(\d{4})/g, '$1 ').trim();
};

export const maskCVV = (cvv) => {
    const cleanCVV = (cvv || '').toString();
    return '•'.repeat(cleanCVV.length) || '•••';
};


// **Importe as imagens no topo do seu arquivo React/JavaScript (exemplo):**
// import mastercardImage from "./mastercard.png";
// import visaImage from "./visa.png";
// const BRAND_IMAGES = { 'Mastercard': mastercardImage, 'Visa': visaImage, ... };
// (No código abaixo, estou usando os caminhos de string fornecidos como exemplo)

export const identifyCardBrand = (cardNumber) => {
    // 1. Definições
    const BRAND_COLORS = {
        'Visa': '#0a79c9',
        'Mastercard': '#8a0aeb',
        'American Express': '#49a7ffff',

        'Diners Club': '#0b82b1',
        'Discover': '#f6802c',
        'JCB': '#000000',
    };

    // Objeto para mapear o nome da marca para o caminho da imagem
    const BRAND_IMAGES = {
        'Mastercard': mastercardImage,
        'Visa': visa,
        'American Express': americanExp,
        'Discover' : discover
    };

    const cleanNumber = cardNumber.replace(/\D/g, '');

    if (!cleanNumber) {
        return null;
    }

    const prefix = cleanNumber;
    let brandName = null;

    // 2. Lógica de Identificação
    
    // Visa: começa com 4
    if (prefix.startsWith('4')) {
        brandName = 'Visa';
    }

    // Mastercard: começa com 51-55 ou 2221-2720
    else if ((prefix.length >= 2 && prefix.substring(0, 2) >= '51' && prefix.substring(0, 2) <= '55') ||
             (prefix.length >= 4 && prefix.substring(0, 4) >= '2221' && prefix.substring(0, 4) <= '2720')) {
        brandName = 'Mastercard';
    }

    // American Express (Amex): 34 ou 37
    else if (prefix.startsWith('34') || prefix.startsWith('37')) {
        brandName = 'American Express';
    }

    // Diners Club: 300-305, 36, 38
    else if ((prefix.length >= 3 && prefix.substring(0, 3) >= '300' && prefix.substring(0, 3) <= '305') ||
             prefix.startsWith('36') || prefix.startsWith('38')) {
        brandName = 'Diners Club';
    }

    // Discover: 6011, 65, 644–649
    else if (prefix.startsWith('6011') || prefix.startsWith('65') ||
             (prefix.length >= 3 && prefix.substring(0, 3) >= '644' && prefix.substring(0, 3) <= '649')) {
        brandName = 'Discover';
    }

    // JCB: começa com 35
    else if (prefix.startsWith('35')) {
        brandName = 'JCB';
    }

    // 3. Retorno Unificado
    if (brandName) {
        return { 
            brand: brandName, 
            color: BRAND_COLORS[brandName] || '#333', // Cor padrão caso falte
            imageUrl: BRAND_IMAGES[brandName] || null // Retorna o caminho da imagem ou null
        };
    }

    // Se não for identificada, retorna null
    return null;
};

export const formatarDataParaISO = (dateMoment) => {
    if (dateMoment && dateMoment.isValid()) {
        return dateMoment.toISOString();
    }
    return "";
};

export const converterValoresBrlParaInteiro = (value) => {
    if (typeof value !== 'string') {
        return parseInt(value) || 0;
    }

    let cleanedValue = value.replace(/\./g, '');
    
    cleanedValue = cleanedValue.replace(/,/g, '.');
    return parseInt(parseFloat(cleanedValue));
};

export const formatarParaStringDecimal = (value) => {
    if (!value) return "0.00";
    if (typeof value === 'number') return value.toFixed(2);

    // 1. Limpar a string no formato BRL para um número float
    let cleanedValue = value.replace(/\./g, ''); // Remove separador de milhar
    cleanedValue = cleanedValue.replace(/,/g, '.'); // Troca vírgula por ponto decimal

    const numberValue = parseFloat(cleanedValue);

    // 2. Retorna a string no formato decimal fixo com 2 casas (ex: "300000.00")
    if (isNaN(numberValue)) return "0.00";

    // O toFixed(2) retorna uma string no formato "x.xx"
    return numberValue.toFixed(2); 
};

export const normalizarNome = (texto) => {
    if (!texto) return '';
    // 1. Remove acentos e caracteres diacríticos (normalização Unicode)
    // 2. Converte para maiúsculas
    // 3. Remove caracteres que não são letras (a-z), números (0-9) ou espaços.
    // 4. Remove espaços no início e no fim.
    return texto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim();
}

const maskFormat = "MM/YYYY";

export const getDateVencimento = (dateValue) => {
    if (!dateValue) return null;
    // Pega o mês e ano selecionados e fixa o dia 15 para padrão de envio
    return Dayjs(dateValue, maskFormat)
      .date(15)
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0)
      .toISOString();
  };

export {formatCNPJ};
export {formatCPF};
export {formatTelefone};
export {formatCEP};
export { formatDateAtaul };
export { handleInputChange };
export { handleInput };
export {formatNumber};
export {formatDate};
export { formatValueBrl }

export { formatarData }
export {formatCurrency}
export { formatValueBrl2 }
export {formatarTamanho}
